/* eslint-disable import/prefer-default-export */
// import { RootState } from '..';
import { IntlState } from './reducer';

export const selectIntl = (state: any) => state.intl;
export const selectLan = (state: any) => state.intl.lan;

